import React, { useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import left from "./assets/arrow-left.png";
import right from "./assets/arrow-right.png";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import img1 from "../../Marketplace/Banner/assets/thum.png";
import img2 from "../../Marketplace/Banner/assets/thum2.png";
import { Navigation } from "swiper";
// import required modules
import { FreeMode, Pagination } from "swiper";
import NftCard from "../../../GlobalComponents/NftCard/NftCard";
import { Link } from "react-router-dom";
const LiveAuctions = () => {
  const responive = {
    // when window width is >= 320px
    300: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1020: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1330: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  };
  const nftCards = [
    { thum: img1 },
    { gold: true, thum: img2 },
    { thum: img1 },
    { gold: true, thum: img2 },
    { thum: img1 },
    { gold: true, thum: img2 },
    { thum: img1 },
  ];
  return (
    <div className="pt-[80px]  liveAuctions white-bol px-4 md:px-0">
      <div className="max-w-[1410px] px-5 2xl:px-0 mx-auto flex justify-between items-center">
        <h1 className=" font-bold text-[28px] md:leading-[44px] md:text-[36px] l leading-[44px] text-main-green">
          Live Auctions
        </h1>
        <Link to="/explore">
          <button className="font-bold text-white text-res-xxs pb-[4px] uppercase">
            <span>Explore more</span>
            <hr className="mt-[5px]     bg-white h-[1px] " />
          </button>
        </Link>
      </div>
      <div className="mt-[40px] pb-[33px] max-w-[1410px] mx-auto relative ">
        <div className="swiper-button z-40 image-swiper-button-next absolute bottom-[49px] left-1/2 ml-[100px] xl:ml-[62px] cursor-pointer">
          <img src={right} alt="" />
        </div>
        <div className="swiper-button image-swiper-button-prev z-40 absolute bottom-[49px] right-1/2 mr-[100px] xl:mr-[62px] cursor-pointer">
          <img src={left} alt="" />
        </div>

        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          breakpoints={responive}
          centeredSlidesBounds={true}
          navigation={{
            nextEl: ".image-swiper-button-next",
            prevEl: ".image-swiper-button-prev",
            disabledClass: "swiper-button-disabled",
          }}
          pagination={{
            clickable: true,
          }}
          modules={[FreeMode, Pagination, Navigation]}
          className="mySwiper"
        >
          {nftCards.map((single, i) => (
            <SwiperSlide key={i}>
              <NftCard thum={single.thum} gold={single.gold}></NftCard>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default LiveAuctions;
